<template>
    <div>
        <!-- Modal -->
        <b-modal id="DeleteDocumentModal" title="Eliminar el documento" centered scrollable header-bg-variant="dark"
            v-model="modalShow">

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

            <!-- cuerpo de cart -->
            <h3>¿Desea eliminar el documento?</h3>

            <!-- fooder -->
            <template #modal-footer>
                <div class="w-100">
                    <button type="button" v-on:click="removeDocument()" class="btn btn-outline-danger">Eliminar</button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';

export default {
    name: 'DocumentDelete',

    data() {
        return {
            modalShow: false,
            documentId: '',

            filterDespuesDeEliminar:{
                pageSize: InitPageSize.DocumentPageSize,
                page: 1
            }
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenModalDocumentDelete, async (query) => {
            this.documentId = query[0].id;
            this.openModal();
        });
    },

    methods:{
        ...mapActions(["deleteDocument"]),

        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },

        async removeDocument(){
            let result = await this.deleteDocument({ documentId: this.documentId });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.$eventBus.$emit(EventNames.DeleteDocument, this.filterDespuesDeEliminar);

            this.closeModal()
        }
    }
}
</script>
<style>
    
</style>